<template>
    <component
        :is="isClickable ? 'inertia-link' : 'div'"
        :key="message.id"
        class="notification-message"
        :href="message.url"
        :class="[message.unread ? 'is-unread' : 'is-read', isClickable ? 'is-clickable' : 'not-clickable']"
    >
        <div class="notification-message-body">
            <h3 class="notification-message-title">
                {{ message.title }}
            </h3>
            <div class="notification-message-message">{{ message.message }}</div>
        </div>
        <footer class="notification-message-footer">
            <span class="notification-message-time" :title="dateTimeHumanReadableFromISO(message.created_at)">{{
                relativeTime(message.created_at)
            }}</span>
        </footer>
    </component>
</template>

<script setup lang="ts">
import { toRef, computed } from 'vue';
import { relativeTime, dateTimeHumanReadableFromISO } from '@src/Common/Helpers/dates';

interface Props {
    message?: {
        id: number;
        title: string;
        message: string;
        url: string;
        unread: boolean;
        created_at: string;
    };
}

const props = withDefaults(defineProps<Props>(), {
    message: () => ({
        id: 0,
        title: '',
        message: '',
        url: '',
        unread: false,
        created_at: '',
    }),
});

const message = toRef(props, 'message');
const isClickable = computed(() => message.value.url !== null && message.value.url !== '#');
</script>
